import { TabOption } from '@urbanx/agx.ui-components2';
import { TeamPageTabs } from './TeamPageTabs';

export const TeamPageTabOptions: TabOption[] = [
  {
    id: TeamPageTabs.TeamMembers,
    label: TeamPageTabs.TeamMembers,
    selected: false,
  },
  {
    id: TeamPageTabs.ManageTeams,
    label: TeamPageTabs.ManageTeams,
    selected: false,
  },
  {
    id: TeamPageTabs.UrbanXTeam,
    label: TeamPageTabs.UrbanXTeam,
    selected: false,
  },
];
